import { render, staticRenderFns } from "./QualityPointInput.vue?vue&type=template&id=faac2c50&"
import script from "./QualityPointInput.vue?vue&type=script&lang=js&"
export * from "./QualityPointInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports